import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCross24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCross24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M17.964 4.764a.9.9 0 0 1 1.273 1.273L13.273 12l5.964 5.964a.9.9 0 0 1-1.273 1.273l-5.963-5.964-5.964 5.963a.9.9 0 0 1-1.273-1.273L10.728 12 4.764 6.037a.9.9 0 0 1 1.273-1.273l5.964 5.964z"
            />
        </svg>
    );
}
export default memo(IconCross24);
